export default [
    {
        path: '/article',
        component: function (resolve) {
            require(['@/pages/brand/article'],resolve)
        }
    },
    {
        path: '/brand/add',
        component: function (resolve) {
          require(['@/pages/brand/add'],resolve)
        }
      },
    {
        path: '/article/index',
        name: 'articleIndex',
        component: function (resolve) {
            require(['@/pages/article/index'],resolve)
        }
    },
    {
        path: '/article/detail',
        name: '长文章-详情',
        component: function (resolve) {
            require(['@/pages/article/detail'],resolve)
        }
    },
    {
      path: '/active/detail',
      name: '动态-详情',
      component: function (resolve) {
          require(['@/pages/article/active-detail'],resolve)
      }
    },
    {
      path: '/wx-public/article-edit',
      name: '微信公众号文章同步',
      component: function (resolve) {
          require(['@/pages/wx-public/article-edit'],resolve)
      }
    },
    {
      path: '/wx/public',
      name: '微信公众号文章同步',
      component: function (resolve) {
          require(['@/pages/article/wx'],resolve)
      }
    },
]


// WEBPACK FOOTER //
// ./src/router/gov.js